import { Input, Typography } from 'antd';
import { RoundedCard } from 'components';
import styled from 'styled-components';

const { Text } = Typography;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const Card = styled(RoundedCard)`
  width: 50%;

  .ant-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const SubTitle = styled(Text)`
  margin-bottom: 1rem;
`;

export const OtpInputField = styled(Input)`
  width: 85%;
`;

export const InvalidTextMsg = styled(Text)`
  align-self: flex-start;
  // margin-left: 2.5rem;
`;

export const ResendCaptchaSection = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// 新增的 OTP 输入框样式
export const OtpInputContainer = styled.div`
  display: flex; /* 水平排列输入框 */
  justify-content: space-between; /* 分配输入框之间的间距 */
  padding-left: 20px;
  width: 100%; /* 设置容器的宽度为100% */
`;

export const OtpInputWrapper = styled.div`
  flex: 1; /* 确保每个输入框均分宽度 */
`;

export const OtpInput = styled(Input)`
  width: 40px; /* 限制输入框的宽度 */
  height: 40px; /* 输入框高度 */
  text-align: center; /* 文字居中 */
  font-size: 20px; /* 设置字体大小 */
  border: 1px solid #ccc; /* 输入框边框 */
  border-radius: 4px; /* 设置圆角 */
`;
export const NewInput = styled(Input)`
  letter-spacing: 24px;
  // padding-left: 27px;
  width: 300px; /* 限制输入框的宽度 */
  height: 48px; /* 输入框高度 */
  text-align: center; /* 文字居中 */
  font-size: 28px; /* 设置字体大小 */
  border: 1px solid #ccc; /* 输入框边框 */
  border-radius: 4px; /* 设置圆角 */
  text-indent: 12px;
  @media (max-width: 576px) {
    width: 250px;
    letter-spacing: 20px;
  }
  @media screen and (min-width: 576px) {
    width: 300px;
  }
`;
